var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIconPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#082CAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42490_2453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 8.00017H10.1C8.83988 8.00017 8.20982 8.00017 7.72852 8.24541C7.30516 8.46112 6.96095 8.80533 6.74524 9.22869C6.5 9.70999 6.5 10.3401 6.5 11.6002V17.9002C6.5 19.1603 6.5 19.7903 6.74524 20.2716C6.96095 20.695 7.30516 21.0392 7.72852 21.2549C8.20982 21.5002 8.83988 21.5002 10.1 21.5002H16.4C17.6601 21.5002 18.2902 21.5002 18.7715 21.2549C19.1948 21.0392 19.539 20.695 19.7548 20.2716C20 19.7903 20 19.1603 20 17.9002V14.7502M11 17.0002H12.2559C12.6228 17.0002 12.8062 17.0002 12.9788 16.9587C13.1319 16.922 13.2782 16.8614 13.4124 16.7791C13.5638 16.6864 13.6935 16.5567 13.9529 16.2972L21.125 9.12517C21.7463 8.50385 21.7463 7.49649 21.125 6.87517C20.5037 6.25385 19.4963 6.25385 18.875 6.87517L11.7029 14.0472C11.4435 14.3067 11.3138 14.4364 11.221 14.5877C11.1388 14.722 11.0782 14.8683 11.0414 15.0213C11 15.194 11 15.3774 11 15.7443V17.0002Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42490_2453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconPatient);
export default __webpack_public_path__ + "static/media/UploadIconPatient.eabc79b257a9ce4c68cd628cc6d1130d.svg";
export { ForwardRef as ReactComponent };